import React from "react";
import { useSearchParams } from "react-router";
import { ComponentList } from "../../../ui";
import { generateFileBrowserLink } from "../../utils";
import LinkToReportTab from "../linkToReportTab/LinkToReportTab";
import styles from "./componentName.module.scss";
const ComponentName = ({ component, id, fileBrowserPage, }) => {
    const [searchParams] = useSearchParams();
    return (React.createElement(ComponentList.Name, { component: component, nameWrapper: (children) => (React.createElement(LinkToReportTab, { id: `${id}-file`, to: generateFileBrowserLink({
                fileBrowserPage,
                searchParams,
                componentId: component.id,
                componentPath: component.path,
            }), className: styles.link, color: "link" }, children)) }));
};
export default ComponentName;
//# sourceMappingURL=ComponentName.js.map